/**
 * Centurylead RFID设备实现（WebSocket版本）
 * 基于理德桌面数据服务DDS WebSocket API
 *  api文档：https://fe-oss.s3.cn-north-1.jdcloud-oss.com/iWMS/api.pdf
 */
import WS from './ws'
import Vue from 'vue'
const defaultOptions = {
  url: 'ws://127.0.0.1:9939/reader',
  apiUrl: 'http://127.0.0.1/api',
  token: '',
  interval: 400,
  timeout: 2000,
  mode: 'EPC',
  responseType: 'INTERVAL',
  power: 10,
  qValue: 4,
  session: 1
}

 const pauseCommand = { action: 'PAUSE' }
 const stopCommand = { action: 'STOP' }
const Centurylead = function(options) {
	 this.options = Object.assign({}, defaultOptions, options)
   this.needStart = false
   this.linkTimer = null
   this._status = null // 'CONNECTING'  链接中 | 'CONNECTED' 已连接 | 'ERROR' 出错 | 'PAUSE'  已暂停
   this.stopIng = false
   this.errorMessage = ''
   Object.defineProperty(this, 'status', {
     get: function() {
       return this._status;
     },
     set: function(newValue) {
      if(this._status  === newValue) return
       this._status = newValue;
       this.onStatusChange();
     }
   });
   this.wsInstance = null
};


Centurylead.prototype.connect = function() {
  
  // 如果已经在运行，或者初始化完了 直接返回
  if (this.status === 'CONNECTED' || this.status === 'INIT') return true

  // 如果处于暂停状态，恢复读取
  if (this.status === 'PAUSE')  return this.start()

  // 如果是链接中，返回true 等待链接完成会有通知
  if (this.status === 'CONNECTING')  return true

  if(!this.options.url){
    console.log('Centurylead: 缺少关键配置，设备链接失败')
    return false
  }
  this.status = 'CONNECTING'
  this.wsInstance = new WS(this.options.url, {
    onmessage: (...arg) => this.onmessage(...arg),
    onclose: (...arg) => this.onclose(...arg),
    onopen: (...arg) => this.onopen(...arg),
    onerror: (...arg) => this.onerror(...arg)
  })
  this.wsInstance.connect()
  this.linkTimer = setTimeout(() => {
    let onchange = this.options.onchange
    this.options.onmessage = null
    this.options.onchange = null
    this.status = 'ERROR'
    onchange && onchange(this.status)
    this.wsInstance.close()
    this.wsInstance = null
  }, this.options.timeout || 2000)
  return true
}


// 处理ws的消息
Centurylead.prototype.onmessage = function(event) {
  this.errorMessage = ''
   try {
    let message = event.data
      const data = JSON.parse(message)
      // 处理数据消息（DATA）
      if (data.type === 'DATA' && data.success) {
        if (data.data && Array.isArray(data.data)) {
          this.options.onmessage && this.options.onmessage(data.data)
        }
      }else if (data.type === 'NOTICE') {  // 设备状态变化
        if(data.action === 'INIT'){
          if(!data.success)this.errorMessage = 'RFID-' + data.message
          this.status = data.success ? 'INIT' : 'ERROR'
        }else if (data.action === 'READERSTATUS') {
          if(data.state === 0 && !this.stopIng) this.status = 'ERROR'
          if(this.stopIng){
            this.stopIng = false
            this.status = null
          }
          // 推送读写状态
          // this.status = data.state === 1 ? this.status : 'ERROR'
        }else if (data.action === 'START_V2') {
          this.status = data.success ? 'CONNECTED' : 'ERROR'
        }else if (data.action === 'STOP') {
          this.stopIng = false
          this.wsInstance.close()
          this.status = data.success ? null : this.status
        }else if (data.action === 'PAUSE') {
          this.status = data.success ? 'PAUSE' : this.status
        }
      }
    } catch (error) {
      console.error('[CenturyleadDevice] 处理消息失败:', error)
    }
}

Centurylead.prototype.onerror = function() {
  clearTimeout(this.linkTimer)
  this.wsInstance = null
  this.status = 'ERROR'
  this.needStart = false
}

Centurylead.prototype.onopen = function() {
  clearTimeout(this.linkTimer)
  // 发送初始化命令
  const initCommand = {
    action: 'INIT',
    data: {
      url: this.options.apiUrl,
      token: this.options.token,
      language: 'zh-CN',
      readPower: this.options.power,
      writePower: 30,
      qValue: this.options.qValue,
      session: this.options.session,
      validTimes: 1,
      repeatSend: true,
      queryTimeout: 3,
      queryResultCacheTime: 60
    }
  }
  this.send(initCommand)
  if(this.needStart){
     this.needStart = false
     this.start()
  }
}

Centurylead.prototype.onclose = function() {
  clearTimeout(this.linkTimer)
	this.wsInstance = null
  // 错误的关闭，要保持错误状态
  if(this.status === 'ERROR') return 
  this.status =  null 
  this.needStart = false
}

Centurylead.prototype.send = function(message) {
	if (!this.wsInstance) {
    console.error('Centurylead WebSocket未连接')
    return false
  }
  return this.wsInstance.send(message)
}

Centurylead.prototype.start = function() {
	 if (this.status === 'CONNECTED') return
	 if (!this.status || !this.wsInstance){
    this.needStart = true
    this.connect()
    return
   }
   this.needStart = false
   this.status = 'CONNECTING'
    try {
      const startCommand = {
        action: 'START_V2',
        data: {
          power: this.options.power,
          qValue: this.options.qValue,
          mode: this.options.mode,
          session: this.options.session,
          interval: this.options.interval,
          rfidFilter: false,
          responseType: this.options.responseType,
          validTimes: 1
        }
      }
      this.send(startCommand)
      return true
    } catch (error) {
      return false
    }
}

Centurylead.prototype.pause = async function() {
    if (this.status !== 'CONNECTED') return false
    try {
      // 等待暂停命令完成
      this.send(pauseCommand)
      return true
    } catch (error) {
      this.emit('error', { message: error.message || '暂停失败' })
      return false
    }
}

Centurylead.prototype.close = async function() {
  if(!this.wsInstance || this.status === 'ERROR'){
    this.wsInstance = null
    this.status = null
     return
  }
  this.stopIng = true
  this.send(stopCommand)
  return true
}


Centurylead.prototype.onStatusChange = function() {
  if(this.status === "ERROR") this.wsInstance && this.wsInstance.close()
  Vue.nextTick(() => {
    this.options.onchange(this.status, this.errorMessage)
  })
}



const CenturyleadDevice = (function() {
	let instance;
	return function(options) {
		if (!instance) {
			instance = new Centurylead(options);
		}else{
      instance.options.onchange && instance.options.onchange(null)
      instance.options =  Object.assign({}, defaultOptions, options)
      instance.options.onchange(instance.status === 'ERROR' ?  null : instance.status)
    }
		return instance;
	}
})();

export default CenturyleadDevice